module.exports = __webpack_public_path__ + "img/IMG-20230301-WA0017.1031ff50.jpg";